
<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";

useBackButton();

</script>

<template>

    <div class="bg-white dark:bg-gray-850
                 w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Recall Notices</strong>
        </div>     

        <div class="w-full dark:bg-gray-900 h-4 border-b dark:border-b-gray-750">&nbsp;</div>
        
    </div>   
    
</template>
